import { Pipe, PipeTransform } from '@angular/core';

/**
 * Drop-in replacement for ng2-search-filter's filter pipe.
 * Usage: | filter:searchText or | filter:searchText:'propertyName'
 */
@Pipe({ standalone: false, name: 'filter' })
export class Ng2FilterPipe implements PipeTransform {
  transform(value: any[] | null | undefined, searchText?: string, property?: string): any[] {
    if (!value || !Array.isArray(value)) return value || [];
    if (!searchText || typeof searchText !== 'string') return value;
    const s = searchText.toLowerCase().trim();
    if (!s) return value;
    return value.filter((item) => {
      const str = property != null && property !== ''
        ? String((item && item[property]) ?? '')
        : JSON.stringify(item);
      return str.toLowerCase().includes(s);
    });
  }
}
